import { trackContactPageEvent } from "../../common/events";
import {expressAddClass, expressEventListener, expressQuerySelector, htmlToElement} from "../../common/html";
import { getCookie } from "../../utils/cookie";
import { initForm } from "../molecules/form";
import { createPopup } from "./popup-new";
import {isTempAccountEmail} from "../../utils/validation";

export interface IOrderDetailsResult {
	found: boolean;
	newParcelHtml: string;
	needsLogout: boolean;
	noOrderFoundLabel: string;
	popupDialogId: string;
	useErrorLabelInPopup: string;
}
export interface IParcelDependencies {
	readonly getOrderDetails: (email: string, ordernumber: string) => Promise<IOrderDetailsResult>;
}

export default function createParcel(containerEl: HTMLElement, deps: IParcelDependencies) {
	const { getOrderDetails } = deps;
	const orderDetails = expressQuerySelector<HTMLElement>(containerEl, ".technical-order-details", false);
	const findOrderForm = expressQuerySelector<HTMLFormElement>(containerEl, ".technical-parcel-tile-order-form", false);

	// get the initial login state & send event
	const initState = containerEl.dataset.initState;
	if (initState) trackContactPageEvent(initState);

	if (orderDetails) {
		const orderOverviewButtonEl = expressQuerySelector<HTMLElement>(orderDetails, ".technical-order-overview-button", true);
		expressEventListener(orderOverviewButtonEl, 'click', _ => trackContactPageEvent('GoToFullOrderOverview'));
	}

	if (!findOrderForm) return;
	const onSubmit = (data: { [inputName: string]: string }) => {
		return getOrderDetails(data['parceltile-find-order-email'], data['ordernumber']).then(res => {
			if (res.useErrorLabelInPopup) {
				const dialogId = res.popupDialogId;

				createPopup(
					{
						view: "GenericPopup",
						dialogId: dialogId,
						forceRefresh: true,
						data:
							{
								BodyLabel: res.useErrorLabelInPopup,
								OkButtonLabel: 'Label.CloseButtonText',
								ExtraPopupCss: 'p-default'
							}
					})
					.then(popup => {
						if (!popup.popup) return;
						const defaultPopupEl = expressQuerySelector<HTMLElement>(popup.popup, '.p-default', true);
						expressAddClass(defaultPopupEl, "m-popup--content-width");
						const dialog = expressQuerySelector<HTMLElement>(document, '#' + dialogId, true);
						const okButton = expressQuerySelector<HTMLElement>(dialog, '.technical-general-popup-ok-button', true);

						okButton.addEventListener("click", function () { popup.close(); });
						popup.openAsync();
					});

				return;
			}

			if (res.found) {
				trackContactPageEvent('SearchParcelSuccess');
				const node = htmlToElement(res.newParcelHtml);
				node && containerEl.replaceWith(node);
				return;
			}

			trackContactPageEvent('SearchParcelFail');

			// reset error text => in case user filled in wrong input first
			form.inputs['ordernumber'].clear(false);
			form.inputs['parceltile-find-order-email'].clear(false);

			// handle order not found exception
			if (res.noOrderFoundLabel) {
				// set label
				form.inputs['ordernumber'].setError(res.noOrderFoundLabel, false);
				form.inputs['parceltile-find-order-email'].setError('', false);
			}
		});
	};

	const form = initForm(findOrderForm, { onSubmitForm: onSubmit });

	const email = getCookie('LastUsedEmail');
	email && !isTempAccountEmail(email) && form.inputs['parceltile-find-order-email'].setValue(email);
}
